import React from 'react'

import { AppearingWrapper, SubsectionTitle } from 'Components/Blocks'
import { Column } from 'Components/UI'

import { useResponsiveLayout } from 'Hooks'

function Title() {
  const { isWideDesktop, isDesktop } = useResponsiveLayout()

  return (
    <Column alignCenter={!isWideDesktop} fullWidth>
      <AppearingWrapper centered={!isWideDesktop} kind="expand">
        <SubsectionTitle
          centered={!isDesktop && !isWideDesktop}
          paragraph="Our Venues include Australia's top courses such as Royal Melbourne, New South Wales, Kingston Heath, The Lakes, Indooroopilly, Sanctuary Cove Pines and many more"
          subtitle="Play at Australia's most prestigious golf courses, with over 90 events annually."
          title="Access Iconic Golf Courses"
        />
      </AppearingWrapper>
    </Column>
  )
}

export default Title
